import { createFileRoute } from "@tanstack/react-router";
import { ServicePage } from "@/components/sections/service-page";
import { pageData } from "@/lib/service-page-data";
const data = pageData["marketplace"];
export const Route = createFileRoute("/software/marketplace")({
  component: () => <ServicePage data={data} />,
  head: () => ({
    meta: [
      { title: `${data.title} — CoderLity` },
      { name: "description", content: data.sub },
      { property: "og:title", content: `${data.title} — CoderLity` },
      { property: "og:description", content: data.sub },
      { property: "og:url", content: "/software/marketplace" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/software/marketplace" }],
  }),
});
